(function (doc) {
    'use strict';
    var current = doc.currentScript;
    var expected = Number(current && current.getAttribute('data-css-expected')) || 1;

    function finish() {
        var links = Array.prototype.slice.call(doc.querySelectorAll('link[data-page-css]'));
        if (links.length < expected) return;
        var complete = links.every(function (link) { return !!link.dataset.ready; });
        var failed = links.some(function (link) { return link.dataset.ready === 'error'; });
        if (!complete && !failed) return;
        links.forEach(function (link) {
            if (link.dataset.ready === 'loaded') link.media = 'all';
        });
        var critical = doc.querySelector('[data-critical-page]');
        if (!critical) return;
        if (complete && !failed) critical.remove();
        else links[links.length - 1].after(critical);
    }

    function loaded(event, failed) {
        var link = event.target;
        if (!link || !link.matches || !link.matches('link[data-page-css]')) return;
        link.dataset.ready = failed ? 'error' : 'loaded';
        finish();
    }
    doc.addEventListener('load', function (event) { loaded(event, false); }, true);
    doc.addEventListener('error', function (event) { loaded(event, true); }, true);
    doc.addEventListener('DOMContentLoaded', function () {
        Array.prototype.forEach.call(doc.querySelectorAll('link[data-page-css]'), function (link) {
            if (!link.dataset.ready && link.sheet) link.dataset.ready = 'loaded';
        });
        finish();
    });
})(document);
